/* Instana */
export const SPEED_GAIN_ASSUMPTION = 2 / 3;

export const PREVENTION_ASSUMPTION = 1 / 3;

export const DEVELOPER_HRLY_RATE = 40;

export const DEVELOPER_YRLY_RATE = 80000;

export const ITOPS_YRLY_RATE = 80000;

export const DEVELOPER_BENEFIT = 0.02; //2% benefit

export const ITOPS_BENEFIT = 0.2; // 20% benefit

export const RS_TEN_THOUSAND = 10000;

export const RS_THIRTY_THOUSAND = 30000;

export const RS_FIFTY_THOUSAND = 50000;

export const RS_TWO_HUNDRED_THOUSAND = 200000;
